import { LAYOUTS, POSITION, } from '@voltmoney/types';
import { ROUTE } from '../../routes';
import { appendURlWithParam, isAccessTokenStale, isMobile, setAppHeader } from "../../configs/utils";
import { PartnerHeader } from "../partnerWeb_Dashboard/partnerHeader";
import { SideBarBuilderDS } from "../sideNavBar";
import { BottomNavBuilderDS } from "../bottomNav";
import { ColorTokens, DividerSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackAlignItems, StackType, StackWidth, WIDGET } from "@voltmoney/schema";
import { navigateByUrl, ShowNewRmContactButton } from "../partnerWeb_Dashboard/utils";
import { getAppHeader } from "../../configs/config";
import { partnerApi, StoreKey } from "../../configs/api";
import { ACTION } from "../partnerWeb_Dashboard/types";
import { handleConnection, onLogoutPress, openMenu } from "../partnerWeb_Dashboard/actions";
import { GoToFaq, GoToHome, GoToPhone, GoToWhatsapp } from "../partnerSignUp/actions";
import { onChangeTab } from "../leads/actions";
import { AppLink } from "../../configs/constants";
const _isMobile = isMobile();
export const template = async (showNewRmContactButton, rmData, partnerAccountId, isFromMobile) => ({
    layout: {
        id: ROUTE.PARTNER_CAPITAL_GAIN,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            {
                id: 'partnerHeader',
                type: WIDGET.STACK,
                position: POSITION.ABSOLUTE_TOP,
            },
            showNewRmContactButton ? { id: 'rmContactButton', type: WIDGET.RM_CONTACT_LIST, position: POSITION.ABSOLUTE_BOTTOM } : {},
            !isMobile()
                ? {
                    id: 'sideNav',
                    type: WIDGET.STACK,
                    position: POSITION.NAVBAR_LEFT,
                }
                : {},
            { id: 'partnerCheckLimitMainStack', type: WIDGET.STACK },
            isFromMobile ? { id: 'BottomNavContainer', type: WIDGET.STACK, position: POSITION.ABSOLUTE_BOTTOM } : {}
        ]
    },
    datastore: {
        rmContactButton: {
            title: 'Contact us',
            rmData,
            handleRmConnection: {
                routeId: ROUTE.PARTNER_CAPITAL_GAIN,
                type: ACTION.HANDLE_CONNECTION,
                payload: {}
            }
        },
        ...await PartnerHeader(ROUTE.PARTNER_CAPITAL_GAIN),
        ...await SideBarBuilderDS(ROUTE.PARTNER_CAPITAL_GAIN),
        ...await BottomNavBuilderDS(ROUTE.PARTNER_CAPITAL_GAIN),
        partnerCheckLimitMainStack: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            alignItems: StackAlignItems.center,
            padding: {
                top: SizeTypeTokens.XXXL,
                left: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXXL,
                right: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXXL,
            },
            widgetItems: [
                { id: 'partnerCheckLimitMainStack1', type: WIDGET.STACK },
            ]
        },
        partnerCheckLimitMainStack1: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            alignItems: StackAlignItems.center,
            maxWidth: 650,
            widgetItems: [
                { id: 'partnerCheckLimitWebView', type: WIDGET.WEB_VIEW },
                { id: 'partnerCheckLimitMainStackSpaceBottom', type: WIDGET.SPACE },
                { id: 'partnerCheckLimitMainStackSpaceBottom1', type: WIDGET.SPACE }
            ]
        },
        partnerCheckLimitMainStack1Divider: {
            size: DividerSizeTokens.SM,
            color: ColorTokens.Grey_Chalk
        },
        partnerCheckLimitMainStack1Stack1: {
            type: _isMobile ? StackType.column : StackType.row,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: 'partnerCheckLimitMainStack1Stack1Item1', type: WIDGET.PARTNER_CHECK_LIMIT_DETAIL_CARD },
                { id: 'partnerCheckLimitMainStack1Stack1Space1', type: WIDGET.SPACE },
                { id: 'partnerCheckLimitMainStack1Stack1Item2', type: WIDGET.PARTNER_CHECK_LIMIT_DETAIL_CARD },
            ]
        },
        partnerCheckLimitMainStack1Stack1Space1: {
            size: SizeTypeTokens.XXXL
        },
        partnerCheckLimitMainStack1Stack1Item2: {
            icon: {
                name: IconTokens.Meter_1,
                size: _isMobile ? IconSizeTokens.XXXL : IconSizeTokens.XXXXXL
            },
            title: 'Check limit manually',
            subTitle: 'No OTP is required. Check limit based on fund name',
            isMobile: _isMobile,
            showComingSoon: true,
            actionItems: []
        },
        partnerCheckLimitMainStack1Space1: {
            size: SizeTypeTokens.XXXL
        },
        partnerCheckLimitWebView: {
            uri: `${AppLink}?isCgtc=true&isIframe=true&source=PARTNER_DASHBOARD_MFC_CGS&partnerAccountId=${partnerAccountId}`,
            isHeightDynamic: true,
            shouldScroll: true,
            iframe: true,
            width: _isMobile ? '100%' : 650,
            eventId: 'getUserData',
            isBordered: true,
            eventAction: {
                routeId: ROUTE.PARTNER_CHECK_LIMIT,
                type: ACTION.GO_TO_REGISTER,
                payload: {}
            }
        },
        partnerCheckLimitMainStackSpaceBottom: {
            size: SizeTypeTokens.Size80
        },
        partnerCheckLimitMainStackSpaceBottom1: {
            size: SizeTypeTokens.Size80
        },
    },
});
export const captionGainStatementMF = {
    onLoad: async ({ network, asyncStorage, openNewTab }, {}) => {
        await setAppHeader();
        const _user = JSON.parse(await asyncStorage.get(StoreKey.userContext));
        let partnerAccountID;
        const accessToken = await asyncStorage.get(StoreKey.accessToken);
        if (!accessToken) {
            await navigateByUrl(ROUTE.PARTNER_SIGNUP, openNewTab, true);
            return;
        }
        const isFromMobile = isMobile();
        appendURlWithParam('capitalGain');
        if (await isAccessTokenStale({ asyncStorage: asyncStorage,
            network: network })) {
            partnerAccountID = _user?.linkedPartnerAccounts[0]?.accountId;
        }
        else {
            partnerAccountID = _user?.linkedPartnerAccounts[0]?.accountId;
        }
        let showNewRmContactButton = false;
        showNewRmContactButton = await ShowNewRmContactButton();
        const header = await getAppHeader();
        const rmContactResponse = await network.get(`${partnerApi.getMappedRMDetails}${partnerAccountID}`, {
            headers: header
        });
        const rmData = rmContactResponse?.data;
        const partnerAccountId = _user?.linkedPartnerAccounts[0]?.accountId;
        return Promise.resolve(template(showNewRmContactButton, rmData, partnerAccountId, isFromMobile));
    },
    actions: {
        [ACTION.HANDLE_CONNECTION]: handleConnection,
        [ACTION.GO_TO_HOME]: GoToHome,
        [ACTION.GO_TO_FAQ]: GoToFaq,
        [ACTION.GO_TO_CALL]: GoToPhone,
        [ACTION.GO_TO_WHATSAPP]: GoToWhatsapp,
        [ACTION.CHANGE_TAB]: onChangeTab,
        [ACTION.LOGOUT]: onLogoutPress,
        [ACTION.OPEN_MENU]: openMenu,
    }
};
